import { createFileRoute } from "@tanstack/react-router";

import { ReleasesPage } from "../../../workspaces/robot-operations/ReleasesPage";

export const Route = createFileRoute("/_console/operations/releases")({
  component: ReleasesPage,
});
